import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { resolveLoggedUserLocale } from "./currencyUtils";

export const useLoggedUser = () => {
  const { employees } = useSelector((state) => state.employees);
  const [loggedUser, setLoggedUser] = useState(null);

  useEffect(() => {
    const locale = resolveLoggedUserLocale(employees);
    const fallbackUser = {
      EmpEmail: localStorage.getItem("email") || "",
      countrycode: locale.countrycode || "",
      region: locale.region || "",
    };
    setLoggedUser(locale.employee || fallbackUser);
  }, [employees]);

  return loggedUser;
};
